


















































import IconBase from "@/common/components/atoms/IconBase.vue";
import IconCreditCard from "@/common/components/icons/IconCreditCard.vue";
import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    IconBase,
    IconCreditCard
  }
})
export default class TheC01ItemFormNotePanelShortage extends Vue {
  @Prop({ type: Number, required: true, default: 0 }) possession!: any;

  @Prop({ type: Boolean, required: false, default: false })
  creditCardEnabled!: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  cartEmpty!: boolean;

  @Prop({ type: Number, required: true, default: 0 }) count!: any;

  @Prop({ type: String, required: true, default: "normal" }) type!: any;

  @Prop({ type: String, required: false, default: "" }) saleEndDate!: string;

  compareSaleEndDate(date: any): boolean {
    if (date == "") {
      return true;
    }
    const endDate = new Date(date);
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    return endDate >= today;
  }
}
